import {SuperJSON} from "superjson";
import {delay, getEasyFs} from "../../google-aistudio/browser/utils.js";
import {doEval, doEventStream, doFetch, getWindowId, zModels, zTask} from "./util.js";
export const superjson = new SuperJSON();

let sessionTi: any;

const sessionHeartbeat = async () => {
  const fs = await getEasyFs();
  const windowId = getWindowId();
  if (!windowId) {
    console.error("Could not determine windowId. Session heartbeat and task processing are disabled.");
    return;
  }

  const models = await fetch(`https://api.groq.com/internal/v1/models`)
    .then((r) => r.json())
    .then((models) => zModels.parse(models).data);
  clearInterval(sessionTi);
  sessionTi = setInterval(() => {
    const session = {
      time: Date.now(),
      models: models,
    };
    fs.writeFile(`${windowId}.groq-session.json`, JSON.stringify(session));
  }, 1000);
};

const processTasks = async () => {
  const fs = await getEasyFs();
  const windowId = getWindowId();
  if (!windowId) return;

  const taskFiles = (await fs.readdir(".")).filter((name) => name.startsWith(`${windowId}.`) && name.endsWith(".json"));

  for (const filename of taskFiles) {
    // 检查是否有正在处理该文件的标志，防止重复进入
    if ((window as any)[`processing_${filename}`]) {
      continue;
    }

    try {
      (window as any)[`processing_${filename}`] = true;

      const content = await fs.readFileText(filename);
      const task = zTask.parse(superjson.parse(content));

      if (task.done) {
        continue;
      }

      console.log(`Processing task: ${task.taskId} of type ${task.type}`);

      // 根据任务类型分发给不同的处理器
      switch (task.type) {
        case "eval":
          for await (const {output} of doEval(task)) {
            await fs.writeFile(filename, superjson.stringify(output));
          }
          break;
        case "fetch":
          for await (const {output} of doFetch(task)) {
            await fs.writeFile(filename, superjson.stringify(output));
          }
          break;
        case "event-stream":
          for await (const {output} of doEventStream(task)) {
            await fs.writeFile(filename, superjson.stringify(output));
          }
          break;
        default:
          console.warn(`No handler for task type: ${(task as any).type}`);
      }
      console.log(`Task completed: ${task.taskId}`);
    } catch (e) {
      console.error(`Error processing task file ${filename}:`, e);
    } finally {
      delete (window as any)[`processing_${filename}`];
    }
  }
};

export const syncEval = async (fps = 3) => {
  await sessionHeartbeat();

  void (async () => {
    while (true) {
      await processTasks();
      await delay(1000 / fps);
    }
  })();
};
